export default __webpack_public_path__ + "static/media/district-profile.ace6f578.svg";